// Validação de estoque para fluxos em massa (Importar via CSV, Auto Completar
// Pedido) — mesma regra da home (ModalEmbalagens.adicionarCarrinho):
// - bloqueio ativo = preferência "bloquearVendaSemEstoque" ligada OU perfil
//   Representante (que nunca pode vender sem estoque);
// - quantidade 'INF' (certificado) nunca bloqueia;
// - quantidade null/undefined ("Sem info") = indisponível quando o bloqueio
//   está ativo;
// - solicitado > disponível = bloqueado.
// A consulta usa SLSEstoqueService.consultarEstoque, que resolve o depósito
// pelo tipo do pedido (doação WD → DOA; demais → LUI/LUN).
import store from '@/store';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import { isPerfilClienteAtivo, isPerfilRepresentanteAtivo } from '@/libs/perfilCliente';

export function bloqueioEstoqueAtivo() {
  try {
    // Cliente NUNCA é bloqueado por estoque: pode pedir qualquer quantidade
    // (o excedente vira backorder e é atendido depois).
    if (isPerfilClienteAtivo()) return false;
    return store.getters['preferencias/bloquearVendaSemEstoque'] || isPerfilRepresentanteAtivo();
  } catch {
    return false;
  }
}

/**
 * Valida o estoque de uma lista de itens.
 * @param {Array<{item_id: string, quantidade: number}>} itens
 * @returns {Promise<Map<string, {motivo: 'sem_info'|'sem_estoque', disponivel: number|null}>>}
 *   Map de item_id → motivo do bloqueio. Vazio quando o bloqueio está
 *   desligado ou tudo tem saldo. Em erro de consulta, com bloqueio ativo,
 *   os itens sem resposta são tratados como "sem_info" (mesma regra da home).
 */
export async function validarEstoqueItens(itens) {
  const bloqueados = new Map();
  if (!bloqueioEstoqueAtivo()) return bloqueados;

  const porItem = new Map();
  (itens || []).forEach((it) => {
    const id = String(it.item_id || '').trim();
    if (!id) return;
    porItem.set(id, (porItem.get(id) || 0) + (Number(it.quantidade) || 0));
  });
  if (porItem.size === 0) return bloqueados;

  let estoqueMap = {};
  try {
    estoqueMap = await new SLSEstoqueService().consultarEstoque([...porItem.keys()]) || {};
  } catch (e) {
    estoqueMap = {};
  }

  porItem.forEach((solicitado, id) => {
    const info = estoqueMap[id];
    const qtd = info ? info.quantidade : null;
    if (qtd === 'INF') return;
    if (qtd === null || qtd === undefined) {
      bloqueados.set(id, { motivo: 'sem_info', disponivel: null });
      return;
    }
    if (solicitado > Number(qtd)) {
      bloqueados.set(id, { motivo: 'sem_estoque', disponivel: Number(qtd) || 0 });
    }
  });
  return bloqueados;
}
